import { render } from "./Table.vue?vue&type=template&id=1191177c&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=1191177c&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/LBP/mi-stock-lbp-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1191177c"]])

export default __exports__